import React, { FC, useMemo } from "react";
import "./Assignee.scss";
import { AuthenticatedAvatar } from "../../../../common/avatar";
import { getInitialsFromName } from "../../../../user";
import { getAvatarUrl } from "../../../../user/utils/utils";
import { useAppSelector } from "../../../../app";
import {
  annotationDoneStatuses,
  doneStatuses,
} from "../../../../common/status/status";

type Props = {
  usePlaceholder?: boolean;
};

const Assignee: FC<Props> = ({ usePlaceholder = false }) => {
  const { activeDocumentSet } = useAppSelector(
    (state) => state.documentSetsReducer,
  );

  const user = useMemo(() => {
    if (!activeDocumentSet) {
      return;
    }

    if (doneStatuses.includes(activeDocumentSet.status)) {
      return activeDocumentSet.approvedBy;
    }
    if (annotationDoneStatuses.includes(activeDocumentSet.status)) {
      return activeDocumentSet.annotatedBy;
    }

    return activeDocumentSet.assignee;
  }, [activeDocumentSet]);

  if (user) {
    const { id, firstName, lastName } = user;
    return (
      <AuthenticatedAvatar
        size={42}
        fontSize={14}
        avatarUrl={getAvatarUrl(id)}
        fallback={getInitialsFromName(firstName, lastName)}
        tooltipTitle={`${firstName} ${lastName}`}
        placement="right"
      />
    );
  }

  if (usePlaceholder) {
    return <div className="assignee-placeholder" />;
  }

  return null;
};

export default Assignee;
